import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cold-calls-listing',
  templateUrl: './cold-calls-listing.component.html',
  styleUrls: ['./cold-calls-listing.component.css']
})
export class ColdCallsListingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  openImportPop() {
    
  }

}



// WEBPACK FOOTER //
// ./src/app/cold-calls-listing/cold-calls-listing.component.ts